import { createAsyncThunk } from '@reduxjs/toolkit';
import { AppDispatch } from 'app/store';
import { MyKnownError, thunkErrorHandler } from 'features/thunkError';
import { ICurrency } from './currenciesTypes';
import { fetchCurrencies } from 'api/currencies';

export const getCurrencies = createAsyncThunk<
  ICurrency[],
  void,
  {
    dispatch: AppDispatch;
    rejectValue: string | unknown;
  }
>('@@currenciesList/getCurrencies', async (_, thunkApi) => {
  try {
    const res = await fetchCurrencies();
    return res.data;
  } catch (err) {
    return thunkErrorHandler(err as MyKnownError, thunkApi.rejectWithValue);
  }
});
